import { Icon } from '@chakra-ui/react';

const CustomCsvIcon = (props) => (
  <Icon viewBox="0 0 23 27" fill="none" {...props}>
    <path
      d="M5.93842 20.025C5.87052 18.5375 4.85444 18.5 3.47538 18.5C1.35186 18.5 1 19.0075 1 21V23.5C1 25.4925 1.35186 26 3.47538 26C4.85444 26 5.87052 25.9625 5.93842 24.475M21.9883 18.5L19.7944 24.3687C19.387 25.4562 19.1845 26 18.8623 26C18.5413 26 18.3363 25.4562 17.9301 24.3687L15.7362 18.5M12.5757 18.5H11.1188C10.5349 18.5 10.2435 18.5 10.0138 18.595C9.23111 18.92 9.24222 19.6812 9.24222 20.375C9.24222 21.0688 9.23111 21.8312 10.0138 22.155C10.2435 22.25 10.5349 22.25 11.1176 22.25C11.7003 22.25 11.9917 22.25 12.2213 22.345C13.0041 22.67 12.993 23.4312 12.993 24.125C12.993 24.8188 13.0041 25.5812 12.2213 25.905C11.9917 26 11.7003 26 11.1176 26H9.53112"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M21.3709 14.75V11.8212C21.3709 10.7987 21.3709 10.2887 21.1832 9.82875C20.9955 9.37 20.6387 9.0075 19.9239 8.285L14.0768 2.365C13.4608 1.74125 13.1533 1.43 12.7706 1.245C12.6914 1.20648 12.6102 1.17226 12.5274 1.1425C12.1286 1 11.6928 1 10.8224 1C6.81611 1 4.81234 1 3.45551 2.1075C3.18154 2.33117 2.93197 2.58386 2.71105 2.86125C1.61719 4.2375 1.61719 6.26375 1.61719 10.32V14.75M12.7286 1.625V2.25C12.7286 5.785 12.7286 7.55375 13.8138 8.65125C14.8978 9.75 16.6448 9.75 20.1363 9.75H20.7536"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default CustomCsvIcon;
